<cc-progress-bar [isLoading]="isLoading$ | async"></cc-progress-bar>
@if (chartView$ | async; as view) {
  <div class="flex flex-col lg:flex-row h-full w-full">
    <div class="w-full lg:w-[70%] min-h-[24rem]">
      @switch (view.type) {
        @case ('error') {
          <div class="p-4 bg-yellow-50 border-l-4 border-yellow-400 dark:bg-yellow-950/40 dark:border-yellow-800">
            <div class="flex">
              <div class="shrink-0">
                <svg
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  data-slot="icon"
                  aria-hidden="true"
                  class="text-yellow-400 dark:text-yellow-300 size-5"
                >
                  <path
                    d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  />
                </svg>
              </div>
              <div class="ml-3">
                <p class="text-sm text-yellow-700 dark:text-yellow-200">
                  {{ view.error.key }}: {{ view.error.value | transloco }}
                </p>
              </div>
            </div>
          </div>
        }
        @case ('chart') {
          <cc-line-chart
            [data]="view.chartData"
            [showLegend]="legend()"
            [legend]="hideFactorLegendItems"
          ></cc-line-chart>
        }
      }
    </div>
    @if (view.type === 'chart' && view.table.length > 0) {
      <div class="flex flex-col w-full lg:w-[30%]">
        <h4 class="text-center">
          {{ 'market-dashboard-details.COMPARISON' | transloco }}
        </h4>
        <table class="table-fixed">
          <tbody>
            @for (item of view.table; track item) {
              <tr>
                <td class="md:w-56">
                  {{ item.name }}
                </td>
                <td class="md:w-28">{{ item.value | number: '.2-2' }}</td>
                <td>{{ item.unit }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
}
